// A reading for display: the number to `digits` places, or "—" when there is none. The API
// sends null for missing or stale readings (NEU-1128, NEU-1133); 0 is a real reading and
// stays 0. Text such as "No power in last hour" is not a number, so it reads "—" too.
export function readingOrDash(value, digits = 2) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  return Number.isFinite(number) ? fixed(number, digits) : "—";
}

/** toFixed without a minus on zero: a tiny negative reading such as -0.001 printed "-0.00"
 *  (NEU-1056). */
export function fixed(number, digits = 2) {
  const text = Number(number).toFixed(digits);
  return Number(text) === 0 ? (0).toFixed(digits) : text;
}
